import React, { useState, useEffect,useContext } from 'react';
import BagsList from './BagsList';
import { FaShoppingCart } from 'react-icons/fa';
import { endpoint } from './endpoint';
import { useNavigate, Link } from "react-router-dom";
import Notiflix from "notiflix";
import { UserContext } from './UserContext'; // Import UserContext
import { useSubscription } from './SubscriptionContext'; // Import SubscriptionContext

const generateGUID = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0,
            v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
};

const CreateCollection = () => {
    const [selectedBags, setSelectedBags] = useState([]);
    const [bagsStatus, setBagsStatus] = useState([]);
     const { user } = useContext(UserContext); const { subscription, isSubscribed } = useSubscription(); // Use SubscriptionContext
    const [collectionID] = useState(generateGUID());
    const navigate = useNavigate();

    const handleBagSelection = (bagId) => {
        setSelectedBags(prevState =>
            prevState.includes(bagId)
                ? prevState.filter(id => id !== bagId)
                : [...prevState, bagId]
        );
    };

    const handleCreateCollection = () => {
        if (selectedBags.length > 0) {
            fetch(`${endpoint}/gymapp/createcollection.php`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    collectionID: collectionID,
                    bags: selectedBags,
                    user: user.email,
                    amount: 0
                }),
            })
            .then(response => response.json())
            .then(data => {
                if (data.status === 'success') {
                    Notiflix.Notify.success('Collection created successfully!');
                    navigate("/dashboard");
                } else {
                    Notiflix.Notify.failure('Failed to create collection. Please try again.');
                }
            })
            .catch(error => {
                console.error('Error:', error);
                Notiflix.Notify.failure('An error occurred. Please try again.');
            });
        } else {
            Notiflix.Report.warning("Missing Bags", 'Please select at least one bag to create a collection.', "Ok");
        }
    };

    useEffect(() => {
        if (!user) return;

        fetch(`${endpoint}/gymapp/getbags.php?token=${user.token}`)
            .then(res => res.json())
            .then(data => {
                setBagsStatus(data.bags);
            });
    }, [user]);

    return (
        <div className="container" style={{ paddingBottom: "100px",paddingTop:"5px" }}>
            <br /><br /><br />
             <h3 className="text-left">Select bags to add to order</h3>
            <hr style={{ marginBottom: "15px" }}/>
            <div className="row justify-content-left">
                <div className="col">
                    {bagsStatus.length > 0 ? (
                       <BagsList
                                bagsStatus={bagsStatus}
                                selectedBags={selectedBags}
                                handleBagSelection={handleBagSelection}
                            />
                    
                    ) : (
                        <p>No bags available. <Link to="/scan">Scan bags you have purchased here</Link></p>
                    )}
                </div>
            </div>
            <hr />
            <div className="container">
                <div className="row justify-content-center">
                    {/* Collection Information Card */}
                    <div className="card payment-card mb-3 col-lg-8 shadow-sm">
                        <div className="card-body">
                            <h4 className="card-title">Collection Information</h4>
                            {/* Cart Details Integrated */}
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <div>
                                    <p className="mb-1">
                                        <strong>Selected Bags:</strong> <span className="ml-2">{selectedBags.length}</span>
                                    </p>
                                </div>
                                <FaShoppingCart 
                                    className="text-light" 
                                    style={{ fontSize: "3rem", padding: "10px" }} 
                                />
                            </div>
                            
                            {/* Create Collection Button */}
                            {isSubscribed ? (
                                <center>
                                    <button 
                                        className="btn btn-dark btn-block" 
                                        onClick={handleCreateCollection}
                                        disabled={selectedBags.length === 0}
                                    >
                                        Create Collection
                                    </button>
                                </center>
                            ) : (
                                <center>
                                    <button 
                                        className="btn btn-dark btn-block" 
                                        onClick={() => navigate("/subscription")}
                                    >
                                        Subscribe Now
                                    </button>
                                </center>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <br /><br /><br />
        </div>
    );
};

export default CreateCollection;
